import React from 'react';
import MessagesCenter from '../../components/MessagesCenter';

/**
 * AdminMessagesCenter — Iter-270 admin inbox page.
 * Same unified inbox component; surfaces admin-relevant cards driven by the
 * `notifications` table (GPS flags, attendance reviews, escalations, system
 * alerts) plus any persisted user_messages dispatched directly to the admin.
 */
const AdminMessagesCenter = () => <MessagesCenter pageTitle="Messages" />;

export default AdminMessagesCenter;
